import axios from './axios_web';

import * as actionTypes from './actionTypes';

export const verifyOTPStart = () => ({
  type: actionTypes.VERIFY_OTP_START,
});

export const verifyOTPSuccess = (data) => ({
  type: actionTypes.VERIFY_OTP_SUCCESS,
  token: data.token,
  expires: data.expires,
});

export const verifyOTPFail = (error) => ({
  type: actionTypes.VERIFY_OTP_FAIL,
  error,
});

export const logInOTPReset = () => ({
  type: actionTypes.LOG_IN_OTP_RESET,
});

export const signUpOTPReset = () => ({
  type: actionTypes.SIGN_UP_OTP_RESET,
});

export const verifyOTPBegin = (email, otp) => (
  (dispatch) => {
    dispatch(verifyOTPStart());
    dispatch(logInOTPReset());
    dispatch(signUpOTPReset());
    const url = '/otp';
    const data = {
      email,
      otp,
    };
    axios.post(url, data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(verifyOTPSuccess(response.data));
        } else {
          dispatch(verifyOTPFail(response.data.detail));
        }
      })
      .catch((err) => {
        let error = err.message;
        if (err.response && err.response.data) {
          error = err.response.data.error;
        }
        dispatch(verifyOTPFail(error));
      });
  }
);
